import api from './api';

export interface OtherExpenseDto {
  id: number;
  expense_date: string;
  received_date: string | null;
  project_id: string;
  description: string;
  category: string | null;
  warehouse: string | null;
  contractor_name: string | null;
  contractor_id: string | null;
  nip: string | null;
  contractor_address: string | null;
  contractor_postal_city: string | null;
  account_number: string | null;
  document_number: string | null;
  net_amount: number;
  vat_rate: string;
  gross_amount: number;
  due_date: string | null;
  paid: boolean;
  paid_date: string | null;
  status: string;
  priority: string;
  payment_method: string | null;
  comment: string | null;
  google_drive_file_id: string | null;
  google_drive_file_url: string | null;
  stored_file_name: string | null;
  created_by_user_id: string | null;
  created_by_name: string | null;
  accounting_approver_user_id: string | null;
  accounting_approval_status: string | null;
  accounting_approval_at: string | null;
  admin_approver_user_id: string | null;
  admin_approval_status: string | null;
  admin_approval_at: string | null;
  transfer_invoice_id: number | null;
  created_at: string;
  updated_at: string;
}

export interface CreateOtherExpensePayload {
  expense_date: string;
  received_date?: string;
  project_id: string;
  description: string;
  category?: string;
  warehouse?: string;
  contractor_name?: string;
  contractor_id?: string | number | null;
  nip?: string;
  contractor_address?: string;
  contractor_postal_city?: string;
  account_number?: string;
  document_number?: string;
  net_amount: number;
  vat_rate: string;
  gross_amount: number;
  due_date?: string;
  priority?: string;
  payment_method?: string;
  comment?: string;
  pdf?: File;
}

export async function createOtherExpense(payload: CreateOtherExpensePayload, googleAccessToken?: string) {
  const form = new FormData();
  Object.entries(payload).forEach(([k, v]) => {
    if (k === 'pdf') return;
    if (v !== undefined && v !== null) form.append(k, String(v));
  });
  if (payload.pdf) {
    form.append('pdf', payload.pdf);
  }
  const { data } = await api.post('/other-expenses', form, {
    headers: {
      'Content-Type': 'multipart/form-data',
      ...(googleAccessToken ? { 'x-google-access-token': googleAccessToken } : {}),
    },
  });
  return data;
}

export async function listOtherExpenses(): Promise<OtherExpenseDto[]> {
  const { data } = await api.get('/other-expenses');
  return data?.data || [];
}

export async function updateOtherExpense(id: number | string, payload: Partial<CreateOtherExpensePayload>) {
  const form = new FormData();
  Object.entries(payload).forEach(([k, v]) => {
    if (k === 'pdf') return;
    if (v !== undefined && v !== null) form.append(k, String(v));
  });
  if (payload.pdf) form.append('pdf', payload.pdf);
  const { data } = await api.patch(`/other-expenses/${id}`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function deleteOtherExpense(id: number | string) {
  const { data } = await api.delete(`/other-expenses/${id}`);
  return data;
}

export async function quickApproveOtherExpense(id: number | string, decision: 'approved' | 'rejected') {
  const { data } = await api.post(`/other-expenses/${id}/quick-approval`, { decision });
  return data;
}

export async function createTransferForOtherExpense(id: number | string) {
  const { data } = await api.post(`/other-expenses/${id}/create-transfer`);
  return data;
}
